import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Sparkle } from '@phosphor-icons/react';

const RecommendationsSection = ({ recommendations }) => {
  const navigate = useNavigate();

  if (!recommendations || recommendations.length === 0) return null;

  return (
    <div className="mb-8" data-testid="recommendations-section">
      <div className="flex items-center gap-2 mb-4">
        <Sparkle weight="duotone" className="w-5 h-5 text-[#C4A35A]" />
        <h2 className="font-heading text-xl font-semibold text-[#1A1918]">Recommended for You</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {recommendations.map((rec, idx) => (
          <motion.div
            key={rec.restaurant?.id || idx}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.05 }}
            className="card-elevated overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() => navigate('/discovery')}
            data-testid={`recommendation-${idx}`}
          >
            <div className="h-32 relative">
              <img
                src={rec.restaurant?.image_url || 'https://images.pexels.com/photos/1327393/pexels-photo-1327393.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'}
                alt={rec.restaurant?.name}
                className="w-full h-full object-cover"
                onError={(e) => { e.target.src = 'https://images.pexels.com/photos/1327393/pexels-photo-1327393.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-2 left-3 right-3">
                <h3 className="text-white font-semibold text-sm truncate">{rec.restaurant?.name}</h3>
                {rec.restaurant?.suburb && (
                  <p className="text-white/70 text-xs flex items-center gap-1">
                    <MapPin weight="fill" className="w-3 h-3" />{rec.restaurant.suburb}
                  </p>
                )}
              </div>
            </div>
            <div className="p-3">
              <p className="text-xs text-[#A94438] font-medium">{rec.reason}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RecommendationsSection;
